"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const R = __importStar(require("ramda"));
const react_apollo_1 = require("react-apollo");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const schema_name_generator_1 = require("@8base/schema-name-generator");
const permissions_provider_1 = require("@8base-react/permissions-provider");
const utils_1 = require("@8base/utils");
class RecordData extends react_1.Component {
    getRecordData(tableSchema, data) {
        const tableItemFieldName = schema_name_generator_1.SchemaNameGenerator.getTableItemFieldName(tableSchema.name);
        const tableAppName = utils_1.tableSelectors.getTableAppName(tableSchema);
        if (tableAppName) {
            return R.path([tableAppName, tableItemFieldName], data);
        }
        return R.path([tableItemFieldName], data);
    }
    render() {
        const _a = this.props, { tableId, variables, tableSchema, children, recordId } = _a, rest = __rest(_a, ["tableId", "variables", "tableSchema", "children", "recordId"]);
        return (react_1.default.createElement(react_apollo_1.Query, Object.assign({}, rest, { query: graphql_tag_1.default(utils_1.createTableRowQueryTag([tableSchema], tableSchema.id, { permissions: this.context.permissions })), variables: { id: recordId } }), (_a) => {
            var { data } = _a, rest = __rest(_a, ["data"]);
            return children(Object.assign(Object.assign({}, rest), { data: this.getRecordData(tableSchema, data) }));
        }));
    }
}
exports.RecordData = RecordData;
RecordData.contextType = permissions_provider_1.PermissionsContext;
//# sourceMappingURL=RecordData.js.map